import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Reserved subdomains that can't be claimed by a tenant. Mirrors the server-side
 * SubdomainPolicy.Reserved so the public form rejects them up front (the backend
 * remains the source of truth and re-validates on approval).
 */
export const RESERVED_SUBDOMAINS = new Set<string>([
  'www', 'api', 'app', 'admin', 'administrator', 'portal', 'mail', 'smtp', 'imap',
  'ftp', 'ns', 'ns1', 'ns2', 'dns', 'cdn', 'static', 'assets', 'media', 'files',
  'blog', 'shop', 'store', 'status', 'support', 'help', 'docs', 'dev', 'test',
  'staging', 'stage', 'demo', 'billing', 'pay', 'payment', 'payments', 'auth',
  'login', 'account', 'accounts', 'dashboard', 'console', 'internal', 'system',
  'root', 'localhost', 'menassaty', 'tenant', 'tenants', 'public', 'secure',
]);

export const SUBDOMAIN_MIN_LENGTH = 3;

/**
 * Validates the optional preferred-subdomain field beyond the format pattern:
 * minimum length and reserved-name blocklist. Empty is allowed (field is optional).
 */
export function subdomainValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').trim().toLowerCase();
    if (!value) return null;

    if (value.length < SUBDOMAIN_MIN_LENGTH) return { subdomainTooShort: true };
    if (RESERVED_SUBDOMAINS.has(value)) return { subdomainReserved: true };

    return null;
  };
}
